import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  bold: {
    fontWeight: 800,
  },
}))

function ShotDeflected({deflector}) {
  const classes = useStyles();

  if(!deflector){
    return null;
  }

  return (
    <>
      {' '}is deflected by{' '}
      <span className={classes.bold}>{deflector.name}</span>
      {' '}and{' '}
    </>
  )
}

export default ShotDeflected;
